import { render, staticRenderFns } from "./embedded_survey_result.vue?vue&type=template&id=023679d4&scoped=true&"
import script from "./embedded_survey_result.vue?vue&type=script&lang=js&"
export * from "./embedded_survey_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023679d4",
  null
  
)

export default component.exports